import React from "react";
import PropTypes from "prop-types";

export const AreasContext = React.createContext();

export default class AreasProvider extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      areas: {},
      getElemByAreaKey: this.getElemByAreaKey,
      setElemByAreaKey: this.setElemByAreaKey
    };
  }

  getElemByAreaKey = key => {
    const result = this.state.areas[key];
    return result;
  };

  setElemByAreaKey = (key, elem) => {
    this.setState(state => {
      let areas = Object.assign({}, state.areas);
      areas[key] = elem;
      return { areas: areas };
    });
  };

  static propTypes = {

    children: PropTypes.object
  };

  render() {
    return <AreasContext.Provider value={this.state}>{this.props.children}</AreasContext.Provider>;
  }
}
